<template>
  <div class="grid-x flex-grow">
    <div class="cell auto cell-block-y flex flex-col flex-grow">
      <div class="flex flex-col flex-grow">
        <div class="flex-grow p-8">
          <div class="flex flex-wrap -m-4">
            <ServiceCard
              v-for="(service, index) in services"
              :key="service.id"
              :service="service"
              :index="index"
              @activate="onActivate"
              @deactivate="onDeactivate"
              @drag-start="onServiceDragStart"
              @drag-end="onServiceDragEnd"
              @drop-sort="onServiceDrop"
              :dragging="+draggedServiceId === +service.id"
            />
          </div>
          <div class="flex flex-row items-end justify-center py-6">
            <ButtonDashed class="flex items-center justify-center w-full h-full min-h-70px"
            v-b-modal="'add'">
              Добавить новую услугу
            </ButtonDashed>
          </div>
        </div>
      </div>
    </div>
    <Modal
      id="deleteService"
      :hide-footer="true"
      >
      <template v-slot:modal-title>
        <span class="modal-title">Удаление услуги</span>
      </template>
      <div slot class="flex flex-col items-center p-8">
        <p class="text-center text-16px leading-22px mb-6 text-muted">
          Вы точно хотите удалить услугу?
        </p>
        <div class="flex items-center justify-center w-full">
          <span
            class="text-16px leading-18px text-danger font-bold cursor-pointer mr-10"
            @click="(e) => onDeleteServiceSend(e, this.serviceId)">
            Удалить
          </span>
          <span
            class="text-16px leading-18px text-secondary font-bold cursor-pointer"
            @click="() => $bvModal.hide('deleteService')">
            Отменить удаление
          </span>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapActions, mapMutations } from 'vuex';
import Modal from '@/components/Modal.vue';
import ButtonDashed from '@/components/ButtonDashed.vue';
import ServiceCard from '@/components/Services/ServiceCard.vue';

export default {
  components: {
    Modal,
    ButtonDashed,
    ServiceCard,
  },
  data() {
    return {
      serviceId: null,
      draggedServiceId: null,
      serviceOrderChanged: false,
    };
  },
  computed: {
    ...mapState({
      categories: (state) => state.services.categories,
    }),
    category() {
      if (this.categories && this.categories.length) {
        return this.categories.find((el) => el.id === this.$route.params.id);
      }
      return {};
    },
    services() {
      if (this.category && !_.isEmpty(this.category)) {
        return this.category.services || [];
      }
      return [];
    },
  },
  methods: {
    ...mapActions(
      'services',
      [
        'ACT_DELETE_SERVICE',
        'ACT_ACTIVATE_CATEGORY_SERVICE',
        'ACT_DEACTIVATE_CATEGORY_SERVICE',
        'ACT_SAVE_CATEGORY_SERVICES_ORDER',
      ],
    ),
    ...mapMutations(
      'services',
      [
        'REORDER_CATEGORY_SERVICES',
      ],
    ),
    moveId(ids, draggedId, targetId, after) {
      const result = ids.filter((id) => +id !== +draggedId);
      const targetIndex = result.findIndex((id) => +id === +targetId);

      if (targetIndex === -1) return ids;

      result.splice(targetIndex + (after ? 1 : 0), 0, draggedId);
      return result;
    },
    onServiceDragStart(serviceId) {
      this.draggedServiceId = serviceId;
      this.serviceOrderChanged = false;
    },
    onServiceDrop({ id: targetId, after }) {
      if (!this.draggedServiceId || +this.draggedServiceId === +targetId) return;

      const currentIds = this.services.map((service) => service.id);
      const nextIds = this.moveId(currentIds, this.draggedServiceId, targetId, after);

      if (nextIds.join(',') !== currentIds.join(',')) {
        this.REORDER_CATEGORY_SERVICES({
          categoryId: this.category.id,
          ids: nextIds,
        });
        this.serviceOrderChanged = true;
      }
    },
    async onServiceDragEnd() {
      const shouldSave = this.serviceOrderChanged;
      this.draggedServiceId = null;
      this.serviceOrderChanged = false;

      if (shouldSave) {
        await this.ACT_SAVE_CATEGORY_SERVICES_ORDER({
          categoryId: this.category.id,
          ids: this.services.map((service) => service.id),
        }).catch(() => {});
      }
    },
    onDeleteService(e, serviceId) {
      this.serviceId = serviceId;
      this.$nextTick(() => {
        this.$bvModal.show('deleteService');
      });
    },
    async onDeleteServiceSend(e, serviceId) {
      await this.ACT_DELETE_SERVICE({
        id: this.category.id,
        serviceId,
      }).then(() => {
        this.$iwalyNotify.success({
          text: 'Услуга успешно удалена!',
        });
        this.$nextTick(() => {
          this.$bvModal.hide('deleteService');
        });
      }).catch((error) => {
        console.log(error);
      });
    },
    onActivate(serviceId) {
      const { id: categoryId } = this.category;
      this.ACT_ACTIVATE_CATEGORY_SERVICE({
        categoryId,
        serviceId,
      });
    },
    onDeactivate(serviceId) {
      const { id: categoryId } = this.category;
      this.ACT_DEACTIVATE_CATEGORY_SERVICE({
        categoryId,
        serviceId,
      });
    },
  },
};
</script>
